import { render, staticRenderFns } from "./autoInspectionReport.vue?vue&type=template&id=ed856144&scoped=true&"
import script from "./autoInspectionReport.vue?vue&type=script&lang=js&"
export * from "./autoInspectionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed856144",
  null
  
)

export default component.exports